import React from 'react';

const STATUS_CONFIG = {
  completed: { label: 'Odbyta', className: 'status-action-btn status-action-btn--primary' },
  no_show: { label: 'Nie przyszła', className: 'status-action-btn status-action-btn--danger' },
  cancelled: { label: 'Odwołana', className: 'status-action-btn status-action-btn--neutral' },
};

export default function StatusActions({ options, onConfirm, disabled = false }) {
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  return (
    <div className="status-actions">
      {options.map((status) => {
        const config = STATUS_CONFIG[status];
        if (!config) return null;

        return (
          <button key={status} type="button" className={config.className} onClick={() => onConfirm(status)} disabled={disabled}>
            {config.label}
          </button>
        );
      })}
    </div>
  );
}